export enum KodataStoresFilterTypes {
  sido = 'addressInfo.sido',
  sgg = 'addressInfo.sgg',
  emd = 'addressInfo.emd',
  nameRegex = 'nameRegex',
  businessItemName = 'businessItemName',
  est3AverageSales = 'est3AverageSales',
}

export enum KodataStoresQueryFilters {
  sido = 'sido',
  sgg = 'sgg',
  emd = 'emd',
  nameRegex = 'nameRegex',
  categories = 'categories',
  salesRanges = 'salesRanges',
}
